<template>
  <b-container>
    <!-- HEADER -->
    <b-row>
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <h3 class="font-weight-bold">Racing Reports</h3>
            <small class="text-muted">
              Thoroughbred, Harness and Greyhound racing analysis
            </small>
          </div>

          <b-button variant="primary" size="sm">
            <feather-icon icon="DownloadIcon" />
            Export
          </b-button>
        </div>
      </b-col>
    </b-row>

    <b-row class="mt-1">
      <b-col cols="12">
        <b-row>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(59, 130, 246);
                background: linear-gradient(
                  rgb(239, 246, 255),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="text-muted">Racing Turnover</span>
              <h3 class="font-weight-bolder">$7.6M</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(16, 185, 129);
                background: linear-gradient(
                  rgb(236, 253, 245),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted"> Racing GGR </span>
              <h3 class="font-weight-bolder">$682K</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(239, 68, 68);
                background: linear-gradient(
                  rgb(254, 242, 242),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">Total Bets</span>
              <h3 class="font-weight-bolder">45,234</h3>
            </b-card>
          </b-col>
          <b-col cols="3">
            <b-card
              class="h-100"
              body-class="p-1"
              style="
                border-left: 4px solid rgb(132, 204, 22);
                background: linear-gradient(
                  rgb(247, 254, 231),
                  rgb(255, 255, 255)
                );
              "
            >
              <span class="mb-1 text-muted">Avg Bet</span>
              <h3 class="font-weight-bolder">$168</h3>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-2 bg-white shadow-lg rounded">
      <b-col cols="12" md="2" class="sidebar p-0 bg-white">
        <div class="sidebar-header">Month/Year</div>

        <div
          v-for="month in months"
          :key="month.id"
          class="sidebar-item"
          :class="{ active: monthActive.id === month.id }"
          @click="handleChangeMonth(month)"
        >
          <div class="font-weight-bolder">{{ month.label }}</div>
          <span class="small text-muted">
            {{ monthActive.id === month.id ? "Current" : month.turnover }}
          </span>
        </div>
      </b-col>

      <b-col cols="12" md="2" class="sidebar p-0 border-left bg-white">
        <div class="sidebar-header">Racing Type</div>
        <div
          v-for="type in racingTypes"
          :key="type.id"
          class="sidebar-item"
          :class="{ active: racingActive.id === type.id }"
          @click="racingActive = type"
        >
          <div class="font-weight-bolder">{{ type.label }}</div>
          <span class="small text-muted">{{ type.bets }}</span>
        </div>
      </b-col>

      <b-col cols="12" md="8" class="content-wrapper p-0">
        <div class="content-header">
          <div class="d-flex justify-content-between align-items-center">
            <strong>
              {{ monthActive.label }} - {{ racingActive.label }} Reports
            </strong>
          </div>
        </div>

        <div v-for="(file, index) in files" :key="index" class="file-row">
          <div
            class="d-flex justify-content-between align-items-center px-2 py-2"
          >
            <div class="d-flex align-items-center">
              <div class="file-icon mr-1">
                <feather-icon icon="FileTextIcon" size="18" />
              </div>

              <div>
                <div class="font-weight-semibold">{{ file.name }}</div>
                <small class="text-muted">{{ file.meta }}</small>
              </div>
            </div>

            <div>
              <b-button size="sm" variant="outline-secondary" class="mr-1">
                <feather-icon icon="EyeIcon" size="14" />
              </b-button>

              <b-button size="sm" variant="primary">
                <feather-icon icon="DownloadIcon" size="14" />
              </b-button>
            </div>
          </div>
        </div>

        <div class="content-footer">
          <b-button size="sm" variant="outline-secondary" class="mr-1">
            Preview
          </b-button>
          <b-button size="sm" variant="primary"> Download All </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {
  BContainer,
  BRow,
  BCol,
  BCard,
  BFormSelect,
  BButton,
} from "bootstrap-vue";

export default {
  components: {
    BContainer,
    BRow,
    BCol,
    BCard,
    BFormSelect,
    BButton,
  },
  data() {
    const months = [
      { id: 1, label: "January 2026", turnover: "$18.4M turnover" },
      { id: 2, label: "December 2025", turnover: "$68.2M turnover" },
      { id: 3, label: "November 2025", turnover: "$63.5M turnover" },
      { id: 4, label: "October 2025", turnover: "$66.8M turnover" },
      { id: 5, label: "September 2025", turnover: "$61.8M turnover" },
    ];
    return {
      months,
      monthActive: months[0],
      racingTypes: [
        { id: 1, label: "All Racing", bets: "45,234 bets" },
        { id: 2, label: "Thoroughbred", bets: "24,567 bets" },
        { id: 3, label: "Harness", bets: "12,345 bets" },
        { id: 4, label: "Greyhound", bets: "8,322 bets" },
      ],

      racingActive: { id: 1, label: "All Racing" },
      files: [
        {
          name: "all_bets_2026-01-06_hourly_12.csv",
          meta: "Generated: Today 12:00 PM • 45.2 MB • 128,456 records",
        },
        {
          name: "all_bets_2026-01-06_hourly_11.csv",
          meta: "Generated: Today 11:00 AM • 42.1 MB • 118,234 records",
        },
        {
          name: "all_bets_2026-01-06_hourly_10.csv",
          meta: "Generated: Today 10:00 AM • 38.7 MB • 105,892 records",
        },
        {
          name: "all_bets_2026-01-06_full.xlsx",
          meta: "Generated: Today 12:00 PM • 156.4 MB • Full day export",
        },
      ],
    };
  },

  methods: {
    handleChangeMonth(month) {
      this.monthActive = month;
    },
  },
};
</script>

<style scoped>
.sidebar-header {
  padding: 16px;
  font-weight: 700;
  border-bottom: 1px solid #e5e7eb;
}

.sidebar-item {
  padding: 16px;
  border-bottom: 1px solid #f1f1f1;
  cursor: pointer;
  transition: 0.2s;
  border-left: 4px solid transparent;
}

.sidebar-item:hover {
  background: #f9fafb;
}

.sidebar-item.active {
  background: #eef2ff;
  border-left-color: #3b82f6;
}

.content-wrapper {
  background: #fff;
}

.content-header {
  padding: 16px;
  border-bottom: 1px solid #e5e7eb;
}

.file-row {
  border-bottom: 1px solid #f1f1f1;
}

.file-row:hover {
  background: #fafafa;
}

.file-icon {
  width: 40px;
  height: 40px;
  background: #fee2e2;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-footer {
  padding: 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  background: #f9fafb;
}
</style>
